import { styled, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import theme from '../../../styles/theme';

const StyledToggleButton = styled(ToggleButton)(() => ({
  fontSize: '16px',
  minWidth: '100px',
  border: 'none',
  textTransform: 'none',
  padding: '5px 10px',
  borderRadius: '20px',

  '&.Mui-selected': {
    background: theme.custom.palette.primary.default,
    color: theme.custom.palette.primary.white,

    '&:hover': {
      background: theme.custom.palette.primary.default,
    },
  },
}));

interface IPeriodButtonGroupProps {
  onChange: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  period: string;
}

const PeriodButtonGroup: React.FC<IPeriodButtonGroupProps> = ({ onChange, period }) => {
  const theme = useTheme();

  return (
    <ToggleButtonGroup
      color="primary"
      value={period}
      exclusive
      onChange={onChange}
      sx={{
        alignSelf: 'center',
        background: theme.custom.palette.primary.white,
        borderRadius: '20px',
        border: `1px solid ${theme.custom.palette.primary.lightgray}`,
      }}
    >
      <StyledToggleButton value={'month'}>Месяц</StyledToggleButton>
      <StyledToggleButton value={'year'}>Год</StyledToggleButton>
    </ToggleButtonGroup>
  );
};

export default PeriodButtonGroup;
